import { Input, Modal, Spin } from "antd"
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import openAiChatCompletion from "controllers/openAiChatCompletion";

const backend = process.env.REACT_APP_BACKEND;

function TranslateInput ({record, dataChangeHandler, curLanguage, gptModel}) {
  const [translateText, setTranslateText] = useState(record.traslate_text)
  const [loading, setLoading] = useState(false)
  const ref = useRef(record.traslate_text)

  const changeValue = async () => {
    try {
      setLoading(true)
      const instance = JSON.parse(JSON.stringify(record))
      instance.translate_text = translateText
      const values = {
        id: record.detail_id, 
        WordExMaster_id: record.id,
        SystemSettingLanguage_code: record.SystemSettingLanguage_code || curLanguage.value,
        translate_text: translateText
      }

      const changePhonetic = await axios.patch(`${backend}/contents/new_word/constituent_false/detail`,{values})
      if(changePhonetic.status === 200) {
        instance.detail_id = changePhonetic.data.data // id를 넣어주어야 중복값이 생기지 않는다.
        dataChangeHandler(instance, "translate_text")
      }
    } catch (err) {
      console.log(err)
      Modal.error({
        title:"에러",
        content: "서버에서 에러가 발생하여 발음기호를 변경하지 못했습니다.",
        okText:"확인",
        afterClose: ()=>{setTranslateText(record.translate_text)}
      })
    } finally {
      setLoading(false)
    }
  }

  const createByGpt = async () => {
    const { word, pos_name, cefr_evp} = record
    const prompt = `Translate '${word}' into Korean when used as a(n) ${pos_name} at the ${cefr_evp} CEFR level. Make sure to provide ONLY ONE most used translation.`
    const translateTextByGpt = await openAiChatCompletion(prompt, gptModel)

    return translateTextByGpt
  }

  const createByGptHandler = async () => {
    try {
      setLoading(true)
      // 해석문장을 state가 아닌 gpt로 변경한다.
      const translateText = await createByGpt()
      if(!translateText) {
        Modal.error({
          title: "GPT에러",
          content: "gpt에 오류가 발생했습니다. 답변 형식이 잘못되어 있을 수 있으니 console을 확인하세요.",
          okText:"확인",
          afterClose: ()=> setLoading(false)
        })
        return
      }

      const instance = JSON.parse(JSON.stringify(record))
      instance.translate_text = translateText
      const values = {
        id: record.detail_id, 
        WordExMaster_id: record.id,
        SystemSettingLanguage_code: record.SystemSettingLanguage_code || curLanguage.value,
        translate_text: translateText
      }

      const changePhonetic = await axios.patch(`${backend}/contents/new_word/constituent_false/detail`,{values})
      if(changePhonetic.status === 200) {
        instance.detail_id = changePhonetic.data.data // id를 넣어주어야 중복값이 생기지 않는다.
        dataChangeHandler(instance, "translate_text")
      }
    } catch (err) {
      console.log(err)
      Modal.error({
        title:"에러",
        content: "서버에서 에러가 발생하여 발음기호를 변경하지 못했습니다.",
        okText:"확인",
        afterClose: ()=>{setTranslateText(record.translate_text)}
      })
    } finally {
      setLoading(false)
    }
  }

  useEffect(()=>{
    setTranslateText(record.translate_text)
  },[record])

  return (
    <div>
      <Spin spinning={loading}>
        <Input 
          style={{width:"150px"}} 
          value={translateText} 
          onFocus={()=>ref.current=translateText}
          onChange={(e)=>setTranslateText(e.target.value)}
          onBlur={changeValue}
        />
        <a style={{margin:"0px 5px"}} onClick={createByGptHandler}>생성</a>
      </Spin>
  </div>
  )
}

export default TranslateInput